import React from 'react';
import { Link } from "react-router-dom";
import './LoginForm.css';
import ResetPassword from './ResetPassword';
const common = require('../common/common');
const env = require("../../config.js").default;

class LoginForm extends React.Component {
  constructor(props){
    super(props);
    this.state = {};
    this.state.loadLogin = false;
    this.state.renderResetPassword = false;
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount(){
    const $ = window.$;
    $(".toggle-password").click((e) => {
      $(".toggle-password i").toggleClass("fa-eye fa-eye-slash");

      if ($("#password").attr("type") === "password") {
        $("#password").attr("type", "text");
      } else {
        $("#password").attr("type", "password");
      }
    });
  }

  handleSubmit (e){
    e.preventDefault();
    const $ = window.$;

    var user = $("[name=login]").val();
    var password = $("[name=password]").val();
    login(user, password);

    return false;
  }

  render(){
    return(
      <>
        <ResetPassword></ResetPassword>
    		<div className="pt-5 pb-5">
          <form onSubmit={this.handleSubmit}>
            <div className="form-signin">
      				<h1 className="h3 mb-3 font-weight-normal text-center">{common.getTrad('Accesso al portale')} {window.cc.companyInfo ? window.cc.companyInfo.service ? window.cc.companyInfo.service : "" : ""}</h1>
      				<div className="col-md-12">
      					<div className="form-group">
      						<label htmlFor="login">{common.getTrad("Username")}: <span className="danger">*</span></label>
      						<input type="text" id="login" name="login" className="form-control mb-3" placeholder={common.getTrad("Username")} autoComplete="username" required autoFocus />
      					</div>
                <div className="form-group">
                  <label htmlFor="password">{common.getTrad("Password")}: <span className="danger">*</span></label>
                </div>
  				      <div className="input-group mb-3">
      						<input type="password" id="password" name="password" className="form-control" placeholder={common.getTrad("Password")} autoComplete="current-password" required aria-describedby="basic-addon2"/>
                  <div className="input-group-append">
                    <span className="input-group-text toggle-password" id="basic-addon2">
                      <i className="fas fa-eye"></i>
                    </span>
                  </div>
              	</div>
      					<div className="alert alert-danger alert-dismissible fade show animated bounceInUp" id="result" role="alert" style={{display: "none"}}></div>
      					<button className="btn-block btn btn-lg bottone_default" type="submit">
                  <i className="fas fa-spinner fa-spin" id="loginLoader" style={{display: "none"}}></i>&nbsp;&nbsp;
                  {common.getTrad("Accedi")}
                </button>
      					<p className="mt-3 mb-4 text-muted text-center">
      						<Link to="/#" data-toggle="modal" data-target="#reset_password">{common.getTrad("Hai dimenticato la password?")}</Link>
      					</p>
              </div>
            </div>
            {window.cc.registrationFlag ?
              <div className="form-signin mt-4">
                <div className="col-md-12">
        					<h2 className="mt-2 mb-3 text-center" style={{"textShadow": "0 0 0", "fontSize": "1.1rem", }}>{common.getTrad("Servizio RMI per Operatore Indipendente")}</h2>
        					<p className="mb-3 text-muted ">
        						<Link className="btn btn-block bottone_default" to="sign-up-io" title={common.getTrad("Registrazione IO")}>{common.getTrad("Registrazione IO")}</Link>
        						<Link className="btn btn-block bottone_default" to="sign-up-employee" title={common.getTrad("Registrazione Dipendente")}>{common.getTrad("Registrazione Dipendente IO")}</Link>
        					</p>
        				</div>
      				</div>
              :
              <></>
            }
    			</form>
    		</div>
      </>
    )
  }
}


function login(user, password){
  const $ = window.$;
  $("#loginLoader").fadeIn("fast");

  $("#result").css("display", "none");

  if(env.CSOFT !== 900000 && !user.startsWith(window.cc.loginname_prefix))
    user = window.cc.loginname_prefix + user;

  var fetchParams;
  fetchParams = {
    method: "POST",
    headers: new Headers({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept-Language': common.getLanguage(true),
      'Authorization': 'Basic ' + btoa(env.BACKEND_LOGIN_CLIENT_ID + ":" + env.BACKEND_LOGIN_CLIENT_SECRET)
    }),
    body: 'grant_type=' + env.BACKEND_LOGIN_GRANT_TYPE + "&username=" + user + "&password=" + password,
  };

  var backend = env.LOGIN_BACKEND ? env.LOGIN_BACKEND : env.BACKEND; //Serve per tenere compatibile con i sistemi che non hanno il settaggio LOGIN_BACKEND
  return fetch(backend + "o/token/", fetchParams).then(function(response) {
    if (!response.ok) {
      var error = Error(response.status);
      error.response = response.json()
      throw error
    }
    return response.json();
  }).then(function(result){
    common.set_localStorage("appState", result.access_token);
    window.location.reload();
  }).catch(async function(error) {
    var resp = await error.response
    console.error("Login Error: " + error + " " + resp)
    $("#result").css("display", "block");
    if(resp !== undefined && resp.error !== undefined){
      if(resp.error === "invalid_grant"){
        $("#result").html(common.getTrad("Errore, username o password errati"));
        return false
      }
    }


    $("#result").html(common.getTrad("Errore, riprovare più tardi"));
  })

}


export default LoginForm;
